module.exports = __webpack_public_path__ + "static/4-dda38cb7630c6fb002523137b6c69e28.jpeg";